import React from "react";
import "./style.scss";
import Button from "components/BaseWidgets/button";
import { BookmarkIcon } from "assets/icons";
import Skeleton from "components/BaseWidgets/skeleton";
import { useRemoveSavedSearch } from "hooks/api/useSearch";
import { displayTextOrDash, getKeyword } from "utils/formatHelper";
import { useNavigate } from "react-router-dom";

function SavedTab({ savedSearches, isLoading, selectOptions, setOpen }) {
  const navigate = useNavigate();
  const { mutate: handleRemove, isLoading: isRemoveLoading } =
    useRemoveSavedSearch({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["savedSearches"] });
      },
    });

  if (isLoading) {
    return (
      <div className="search-tab-items saved-tab">
        {[...Array(3)].map((_, i) => (
          <Skeleton key={i} height={138} label={false} />
        ))}
      </div>
    );
  }

  return (
    <div className="saved-tab search-tab-items">
      {savedSearches.length === 0 ? (
        <p>No saved searches found.</p>
      ) : (
        savedSearches.map((item) => {
          const handleSelect = () => {
            const params = new URLSearchParams();

            // If there's a non-null keyword, use that only
            if (item.keyword) {
              params.set("k", item.keyword);
              params.set("st", "1");
            } else {
              // No keyword — process filter_data normally
              Object.entries(item.filter_data || {}).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                  value.forEach((v) => params.append(key, v));
                } else if (value !== undefined && value !== null) {
                  params.set(key, value);
                }
              });
              params.set("st", "2");
            }

            navigate(`/s/${item.id}?${params.toString()}`);
            setOpen(false);
          };
          return (
            <div key={item.id} className="card-container">
              <div
                onClick={handleSelect}
                className="flex flex-col gap-4 pointer"
              >
                <div>
                  <span className="font-body-lg fw-700">
                    {displayTextOrDash(item.keyword)}
                  </span>
                  <p className="mt-1 date-text">
                    {displayTextOrDash(item.date)}
                  </p>
                </div>
                <p className="font-body-lg fw-400">
                  {(() => {
                    let filterData = item.filter_data;

                    if (typeof filterData === "string") {
                      try {
                        filterData = JSON.parse(filterData);
                      } catch (e) {
                        console.error(
                          "Invalid JSON in filter_data",
                          filterData,
                        );
                        filterData = {};
                      }
                    }

                    return filterData
                      ? getKeyword({ filter_data: filterData }, selectOptions)
                      : displayTextOrDash(filterData);
                  })()}
                </p>
              </div>
              <div className="flex items-center gap-4">
                <Button
                  height={40}
                  variant="secondary"
                  className="action-btn"
                  isDisabled={isRemoveLoading}
                  onClick={() => handleRemove({ id: item.id })}
                >
                  <BookmarkIcon />
                </Button>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

export default SavedTab;
